export default __webpack_public_path__ + "static/media/ic-notification.fe55e3e0.svg";